import React, { useEffect } from 'react';

import Accordion, { AccordionProps } from '../../components/accordion';
import { Header } from '../../components/header/header';
import Container from './container';
import {
    barneforsikring,
    helseforsikringOgBehandlingshjelp,
    inntektsforsikring,
    personforsikring,
    personskadeTrafikkulykke,
    personskadeUlykke,
} from './skade-melding-ark';
import Yrkesskade from './skade-melding-ark/yrkesskade';

const skadeTyper: AccordionProps[] = [
    { tittel: 'Barneforsikring', children: barneforsikring },
    { tittel: 'Helseforsikring og hjelp til behandling', children: helseforsikringOgBehandlingshjelp },
    { tittel: 'Inntektsforsikring', children: inntektsforsikring },
    { tittel: 'Personforsikring: uførhet, kritisk sykdom eller dødsfall', children: personforsikring },
    { tittel: 'Personskade ved ulykke', children: personskadeUlykke },
    { tittel: 'Personskade ved trafikkulykke', children: personskadeTrafikkulykke },
    { tittel: 'Yrkesskade eller yrkessykdom', children: <Yrkesskade /> },
].map((props) => ({ ...props, key: props.tittel.toLocaleLowerCase().replace(/\s/g, '_') }));

export const LivOgHelseComponent = () => {
    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    const header = (
        <Header
            title="Liv og helse"
            subtitle="Få hjelp ved sykdom eller skade på person, eller behov for behandling. Ha forsikringsnummeret ditt klart så kan vi hjelpe deg raskere."
        />
    );

    return <Container header={header}>{skadeTyper.map(Accordion)}</Container>;
};
